module.exports = __webpack_public_path__ + "img/Q99.52236540.jpg";